module.exports = __webpack_public_path__ + "img/30.3D可视化&数字孪生图片-已选择.989ec3f7.png";